<template>
<div class="grid_adventskalender">
                <KalenderCard2/>
                <KalenderCard7/>
                <KalenderCard9/>
                <KalenderCard19/>
                <KalenderCard8/>
                <KalenderCard10/>
                <KalenderCard16/>
                <KalenderCard13/>
                <KalenderCard3/>
                <KalenderCard5/>
                <KalenderCard15/>
                <KalenderCard4/>
                <KalenderCard12/>
                <KalenderCard18/>
                <KalenderCard1/>
                <KalenderCard21/>
                <KalenderCard14/>
                <KalenderCard20/>
                <KalenderCard17/>
                <KalenderCard24/>
                <KalenderCard6/>
                <KalenderCard23/>
                <KalenderCard22/>
                <KalenderCard11/>
        </div>
    <!--
    <div class="jumbotron_adventskalender">
      <div class="container_adventskalender">
        <div class="grid_adventskalender">
                <KalenderCard2/>
                <KalenderCard7/>
                <KalenderCard9/>
                <KalenderCard19/>
                <KalenderCard8/>
                <KalenderCard10/>
                <KalenderCard16/>
                <KalenderCard13/>
                <KalenderCard3/>
                <KalenderCard5/>
                <KalenderCard15/>
                <KalenderCard4/>
                <KalenderCard12/>
                <KalenderCard18/>
                <KalenderCard1/>
                <KalenderCard21/>
                <KalenderCard14/>
                <KalenderCard20/>
                <KalenderCard17/>
                <KalenderCard24/>
                <KalenderCard6/>
                <KalenderCard23/>
                <KalenderCard22/>
                <KalenderCard11/>
        </div>
      </div>
    </div>
    -->
</template>
<script>
import KalenderCard1 from './KalenderCard1.vue';
import KalenderCard2 from './KalenderCard2.vue';
import KalenderCard3 from './KalenderCard3.vue';
import KalenderCard4 from './KalenderCard4.vue';
import KalenderCard5 from './KalenderCard5.vue';
import KalenderCard6 from './KalenderCard6.vue';
import KalenderCard7 from './KalenderCard7.vue';
import KalenderCard8 from './KalenderCard8.vue';
import KalenderCard9 from './KalenderCard9.vue';
import KalenderCard10 from './KalenderCard10.vue';
import KalenderCard11 from './KalenderCard11.vue';
import KalenderCard12 from './KalenderCard12.vue';
import KalenderCard13 from './KalenderCard13.vue';
import KalenderCard14 from './KalenderCard14.vue';
import KalenderCard15 from './KalenderCard15.vue';
import KalenderCard16 from './KalenderCard16.vue';
import KalenderCard17 from './KalenderCard17.vue';
import KalenderCard18 from './KalenderCard18.vue';
import KalenderCard19 from './KalenderCard19.vue';
import KalenderCard20 from './KalenderCard20.vue';
import KalenderCard21 from './KalenderCard21.vue';
import KalenderCard22 from './KalenderCard22.vue';
import KalenderCard23 from './KalenderCard23.vue';
import KalenderCard24 from './KalenderCard24.vue';

export default {
  name: 'KalenderAnsicht',
  components: {
    KalenderCard1,
    KalenderCard2,
    KalenderCard3,
    KalenderCard4,
    KalenderCard5,
    KalenderCard6,
    KalenderCard7,
    KalenderCard8,
    KalenderCard9,
    KalenderCard10,
    KalenderCard11,
    KalenderCard12,
    KalenderCard13,
    KalenderCard14,
    KalenderCard15,
    KalenderCard16,
    KalenderCard17,
    KalenderCard18,
    KalenderCard19,
    KalenderCard20,
    KalenderCard21,
    KalenderCard22,
    KalenderCard23,
    KalenderCard24,
  },
}
//document.addEventListener('contextmenu', event => event.preventDefault());
</script>
<style scoped lang="scss">
@import './../scss/variablen.scss';
@import './../scss/mixins.scss';
/*
.jumbotron_adventskalender {
    background: url('./../assets/images/bg-kalender-2.webp') left bottom no-repeat;
    background-size: 100%;
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    .jumbotron_adventskalender {
        background: url('./../assets/images/bg-kalender-2.jpg') left bottom no-repeat;
        background-size: 100%;
    }
}
@media screen and (min-width:0\0) and (min-resolution:.001dpcm) {
    .jumbotron_adventskalender {
        background: url('./../assets/images/bg-kalender-2.jpg') left bottom no-repeat;
        background-size: 100%;
    }
}
.container_adventskalender {
  width: 100%;
  padding-right: var(--bs-gutter-x, 0.75rem);
  padding-left: var(--bs-gutter-x, 0.75rem);
  margin-right: auto;
  margin-left: auto;
  padding-top: 30px;
  padding-bottom: 30px;
  @include breakpoint($MEDIA_SM) { 
    max-width: 540px;
  }
  @include breakpoint($MEDIA_MD) { 
    max-width: 720px;
  }
  @include breakpoint($MEDIA_LG) { 
    max-width: 960px;
  }
  @include breakpoint($MEDIA_XL) { 
    max-width: 1140px;
  }
  @include breakpoint($MEDIA_XXL) { 
    max-width: 1320px;
  }
}
*/
.grid_adventskalender {
  display: grid;
  grid-gap: 1em;
  grid-template-columns: repeat( auto-fill, minmax( 130px, 1fr ) );
  grid-auto-rows: 150px;
  @include breakpoint($MEDIA_SM) { 
    grid-template-columns: repeat( auto-fill, minmax( 150px, 1fr ) );
  }
  @include breakpoint($MEDIA_MD) { 
    grid-template-columns: repeat( auto-fill, minmax( 180px, 1fr ) );
  }
  @include breakpoint($MEDIA_LG) { 
    grid-template-columns: repeat( auto-fill, minmax( 200px, 1fr ) );
  }
}
</style>